import { Button, Label } from 'flowbite-react';
import React, { useState } from 'react';
import { MultiValue, SingleValue } from 'react-select';
import Select from 'react-select';
import { Dropdown } from 'shared-utils';
import { CallLogsDispositions, FilterLeadGenInput, LeadGensource, LeadGensUser, Source, Status, UIUser } from 'types';
import { useUserContext } from 'src/context/UserProvider';
import moment from 'moment';
import Datepicker, { DateValueType } from 'react-tailwindcss-datepicker';


const LeadGenFilterForm = ({
	leadGen,
	onClose,
	onApply,
	onClear,
	allLeadGensUser,
	myBDPOCsData,
	allLeadGensSource
}: {
	leadGen?: string;
	onClose?: () => void;
	onApply?: () => void;
	onClear?: () => void;
	allLeadGensUser?: LeadGensUser[];
	myBDPOCsData: {
		bds: UIUser[];
	};
	allLeadGensSource?: LeadGensource[]
}) => {
	const { setLeadGenFilters } = useUserContext();
	const dateFormat = 'YYYY-MM-DD';
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [filters, setFilters] = useState<FilterLeadGenInput | null>();

	const [status, setStatus] = useState<MultiValue<Dropdown>>([]);
	const [callLogStatus, setCallLogStatus] = useState<MultiValue<Dropdown>>([])
	const [leadGenPOC, setLeadGenPOC] = useState<MultiValue<Dropdown>>([]);
	const [bdPOC, setBdPOC] = useState<MultiValue<Dropdown>>([]);
	const [source, setSource] = useState<MultiValue<Dropdown>>([]);
	const [isArchive, setIsArchive] = useState<string | null>(null);


	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				const filterData = {
					status: JSON.stringify(status.map(val => val.value) || []),
					callLogStatus: JSON.stringify(callLogStatus.map(val => val.value) || []),
					leadGenPOC: JSON.stringify(leadGenPOC.map(val => val.value) || []),
					bdPOC: JSON.stringify(bdPOC.map(val => val.value) || []),
					source: JSON.stringify(source.map(val => val.value) || []),
					leadGenFromDate: fromDate ? new Date(fromDate) : undefined,
					leadGenToDate: toDate ? new Date(toDate) : undefined,
					isArchived: isArchive || "",
				}
				if (filters) {
					setLeadGenFilters(filterData);
				}
			}}
		>
			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="skill" className="font-[700] font-inter text-sm text-[#28293D]" value="Status" />
				</div>

				<Select
					isClearable
					isMulti
					options={Object.values(Status).map(source => ({
						label: source,
						value: source,
					}))}
					onChange={(vals: MultiValue<Dropdown>) => {
						setStatus(vals);
						setFilters(prev => {
							return { ...prev };
						});
					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="New, DNP"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={status}
				/>
			</div>

			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="calllogstatus" className="font-[700] font-inter text-sm text-[#28293D]" value="Call Log Status" />
				</div>

				<Select
					isClearable
					isMulti
					options={Object.values(CallLogsDispositions).map(calllogstatus => ({
						label: calllogstatus,
						value: calllogstatus,
					}))}
					onChange={(vals: MultiValue<Dropdown>) => {
						setCallLogStatus(vals);
						setFilters(prev => {
							return { ...prev };
						});
					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="No POC,Positive"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={callLogStatus}
				/>
			</div>

			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="skill" className="font-[700] font-inter text-sm text-[#28293D]" value="LeadGen POC" />
				</div>

				<Select
					isClearable
					isMulti
					options={allLeadGensUser?.map(user => ({ label: user.name, value: user._id })) as Dropdown[]}
					onChange={(vals: MultiValue<Dropdown>) => {
						setLeadGenPOC(vals);
						setFilters(prev => ({
							...prev
						}));
					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="Select LeadGen POC"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={leadGenPOC}
				/>
			</div>


			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="skill" className="font-[700] font-inter text-sm text-[#28293D]" value="Asigned BD" />
				</div>

				<Select
					isClearable
					isMulti
					options={myBDPOCsData?.bds?.map(user => ({ label: user.name, value: user._id }))}
					onChange={(vals: MultiValue<Dropdown>) => {
						setBdPOC(vals);
						setFilters(prev => ({
							...prev,

						}));

					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="Select BD"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={bdPOC}
				/>
			</div>

			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="location" className="font-[700] font-inter text-sm text-[#28293D]" value="Source" />
				</div>

				<Select
					isClearable
					isMulti
					options={allLeadGensSource?.map(source => ({
						label: source?.sourceName || '',
						value: source?.sourceName || '',
					}))}
					onChange={(vals: MultiValue<Dropdown>) => {
						setSource(vals);
						setFilters(prev => ({
							...prev,

						}));

					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="Google Ads, LinkedIn Ads"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={source}
				/>
			</div>

			<div className="mt-[20px] whiteBgSelect">
				<div className="mb-4 block">
					<Label htmlFor="location" className="font-[700] font-inter text-sm text-[#28293D]" value="Show isArchived" />
				</div>

				<Select
					isClearable
					options={[{ label: "IsArchived", value: "isArchived" }]}
					onChange={(newValue: SingleValue<Dropdown>, actionMeta: any) => {
						setIsArchive(newValue ? newValue.value : null);
						setFilters(prev => ({
							...prev,
						}));
					}}
					menuPlacement="auto"
					className="[&>*]:!min-h-[46px]"
					classNamePrefix="my-select-plans"
					placeholder="select isArchived"
					blurInputOnSelect={false}
					closeMenuOnSelect={false}
					value={isArchive ? { label: "IsArchived", value: isArchive } : null}
				/>
			</div>

			{/* Filter for range date */}
			<div className="mt-[28px]">
				<div className="mb-6 block">
					<Label
						htmlFor="createdAt"
						className="font-[700] font-inter text-sm text-[#28293D]"
						value="Lead Gen Date Range"
					/>
				</div>

				<Datepicker
					useRange={false}
					value={{
						startDate: fromDate ? moment(fromDate).toDate() : null,
						endDate: toDate ? moment(toDate).toDate() : null,
					}}
					onChange={(event: DateValueType) => {
						if (event) {
							const [startDate, endDate] = [event.startDate, event.endDate];
							setFromDate(startDate ? moment(startDate).format(dateFormat) : '');
							setToDate(endDate ? moment(endDate).format(dateFormat) : '');
							setFilters(prev => {
								return { ...prev };
							});
						}
					}}
					inputClassName="w-full rounded-md border border-[#d1d5db] font-inter focus:ring-0 font-normal bg-[#FFF] placeholder:text-[#555770]"
					placeholder="Select a date range"
				/>
			</div>
			<div className="flex flex-wrap gap-[20px] mt-[17px]">
				<Button
					type="reset"
					color="light"
					// disabled={filterCandidatesFn.isLoading}
					className="flex-1"
					onClick={() => {
						setStatus([]);
						setCallLogStatus([]);
						setLeadGenPOC([]);
						setBdPOC([]);
						setSource([]);
						setFilters(null);
						setLeadGenFilters({} as FilterLeadGenInput);
						setIsArchive(null);
						setFromDate('')
						setToDate('')
						onClear && onClear();
					}}
				>
					Clear
				</Button>
				<Button
					type="submit"
					color="purplePlaced"
					className="flex-1 bg-[#7777E7]"
					onClick={onApply}
				>
					Apply
				</Button>
			</div>
		</form>
	);
};

export default LeadGenFilterForm;
